import { useState } from "react";
import { useApi } from "../../utils/api/useApi";
import { resetPasswordInitiateEndpoint } from "../../utils/api/urls";
import { PasswordResetDto } from "../../models/PasswordResetDto";

export const useSubmitResetEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { post } = useApi<void>();

  const submitResetEmail = async (passwordResetDto: PasswordResetDto) => {
    setLoading(true);
    setError(null);

    try {
      await post(
        resetPasswordInitiateEndpoint,
        { email: passwordResetDto.email, language: passwordResetDto.language },
        { headers: { "X-Kamstrup-WorkflowId": passwordResetDto.workflowId } }
      );
    } catch (err: any) {
      setError(err.message || "Failed to send email.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { submitResetEmail, loading, error };
};
